export const TogglesAction = {
    Get: "toggles.get",
    Set: "toggles.set",
};
